module.exports = __webpack_public_path__ + "media/images/flags/az-fbb3035af9a5827dbac123546a7c88a6.svg";